import React from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { t } from 'helpers/i18n';
import './VersionNamingRulePopup.scss';

export interface VersionNamingRulePopupProps {
  handleCloseModal: () => void;
}

function VersionNamingRulePopup(props: VersionNamingRulePopupProps) {
  const { } = useSelector(
    (state: RootState) => state.projectDetail
  );


  return (
    <Modal
      open={true}
      title={t('version_code_naming_rule')}
      footer={null}
      onCancel={props.handleCloseModal}
    >
      <div className="version_naming_rule_popup_container">
        <p
          style={{ whiteSpace: 'pre-line' }}
          dangerouslySetInnerHTML={{
            __html: t('version_code_naming_rule_content', {
              href: 'https://semver.org/',
            })
          }}
        />
        <div style={{ height: '8px' }} />
      </div>

    </Modal>
  );
}

export default VersionNamingRulePopup;
